import * as yup from "yup";

import { Button, Grid } from "@mui/material";

import AutoComplete from "../../../../components/hookForms/autoComplete";
import CloseIcon from "@mui/icons-material/Close";
/* eslint-disable react-hooks/exhaustive-deps */
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FileInputButton from "../../../../components/fileInputButton";
import IconButton from "@mui/material/IconButton";
import { Loader } from "./styles";
import { getBase64 } from "../../../../utils/utils";
import messages from "../../../../utils/messages";
import { s3upload } from "../../../../utils/s3";
import serviceFaturaUsina from "../../../../services/serviceFaturaUsina";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import serviceModeloFatura from "@/services/serviceModeloFatura";
import TextInput from "@/components/hookForms/textField";

export interface IDialogProps {
    open: boolean;
    onSuccess: () => void;
    onClose?: any;
}

export default function DialogLoad({ open, onClose, onSuccess }: IDialogProps) {
    const [modeloDataOptions, setModeloDataOptions] = useState<any[]>([]);
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedFileBase64, setSelectedFileBase64] = useState("");
    const [isDisable, setDisable] = useState(false);

    const validationSchema = yup.object().shape({
        modeloFaturaId: yup.string().required(messages.requiredField),
    });

    const {
        control,
        handleSubmit,
        reset,
        setValue,
        resetField,
        formState: { errors },
        // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            concessionaria: "",
            modeloFaturaId: "",
        },
    });

    useEffect(() => {
        setModeloData();
    }, []);

    const handleFileInput = (e: any) => {
        const extension = e.target.files[0].name.split(".").pop().toLowerCase();

        if (["pdf"].includes(extension)) {
            setSelectedFile(e.target.files[0]);

            getBase64(e.target.files[0]).then((result) => {
                setSelectedFileBase64(result);
            });
        } else {
            toast.error("O arquivo selecionado é inválido. É necessário anexar a fatura no formato PDF!");
            clearFile();
        }
    };

    const onSubmit = (values: any) => {
        setDisable(true);

        if (!selectedFile || !selectedFileBase64) {
            toast.error("É necessário anexar o PDF da fatura.");
            setDisable(false);
        } else {
            const chargeValues = {
                ...values,
                modeloFaturaId: Number(values.modeloFaturaId),
                fileBase64: selectedFileBase64,
            };

            serviceFaturaUsina
                .charge(chargeValues)
                .then((result) => {
                    if (result && result.data && result.data.faturaUsinaID) {
                        toast.success("Fatura carregada com sucesso!");
                        onClose(true);
                        onSuccess();
                        reset();

                        //Realiza o Upload da Fatura para o Bucket principal
                        const bucket = process.env.REACT_APP_S3_BUCKET_FATURAS_USINA || "";

                        s3upload(
                            bucket,
                            `${result.data.nomeUsina}/${result.data.faturaUsinaID.toString()}.pdf`,
                            selectedFileBase64
                        );
                    }
                })
                .finally(() => {
                    setDisable(false);
                    clearFile();
                });
        }
    };

    const setModeloData = async () => {
        serviceModeloFatura
            .getAllModelos()
            .then((result) => {
                setModeloDataOptions(result?.data);
            })
            .catch(() => {
                setModeloDataOptions([]);
            });
    };

    const onCancelLoad = () => {
        clearFile();
        reset();
        onClose(true);
    };

    const clearFile = () => {
        setSelectedFile(null);
        setSelectedFileBase64("");
    };

    return (
        <Dialog
            maxWidth="md"
            fullWidth
            onClose={(_, reason) => {
                if (reason !== "backdropClick") {
                    onClose();
                }
            }}
            open={open}
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogTitle>
                    Carregar Fatura
                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            onCancelLoad();
                        }}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            {isDisable && (
                                <Loader>
                                    <img alt="Loading" src="/Loading.gif" width="40px" height="40px" />
                                </Loader>
                            )}
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <AutoComplete
                                id="modeloFaturaId"
                                name="modeloFaturaId"
                                label="Modelo"
                                options={modeloDataOptions?.map((data) => {
                                    return { value: data.modeloFaturaId, label: data.descricaoModelo };
                                })}
                                onChange={(id) => {
                                    const modelo = modeloDataOptions.find((modelo) => modelo.modeloFaturaId === id);
                                    if (modelo.nomeConcessionaria) {
                                        setValue("concessionaria", modelo.nomeConcessionaria);
                                    }
                                }}
                                onInputChange={(_, __, reason) => {
                                    if (reason === "clear") {
                                        resetField("concessionaria");
                                    }
                                }}
                                control={control}
                                error={errors}
                            />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <TextInput
                                id="concessionaria"
                                name="concessionaria"
                                label="Concessionária"
                                control={control}
                                error={errors}
                                disabled
                            />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <FileInputButton
                                accept="application/pdf"
                                onChange={handleFileInput}
                                selectedFile={selectedFile}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                    <Button
                        onClick={() => onCancelLoad()}
                        color="warning"
                        variant="contained"
                        style={{ width: "159px", height: "44px" }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        type="submit"
                        color="primary"
                        variant="contained"
                        disabled={isDisable}
                        style={{ width: "159px", height: "44px" }}
                    >
                        Carregar
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}
